import { DesignTokens } from "../../types"

export const createIconSizes: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.IconSizes = ({ sizes }) => ({
  xxSmall: sizes[12],
  xSmall: sizes[14],
  small: sizes[16],
  medium: sizes[24],
  large: sizes[32],
})

export const createIconColors: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.IconColors = ({ colors }) => ({
  default: colors.gray050,
  inverse: colors.white,
  brand: colors.green400,
  interactive: colors.blue600,
  urgent: colors.red600,
  rating: colors.yellow600,
  disabled: colors.gray400,
  subdued: colors.gray600,
  placeholder: colors.gray600,
  discount: colors.green400,
  accent: colors.purple600,
  success: colors.green400,
  informational: colors.blue400,
  navigation: colors.black,
  selection: colors.blue600,
  action: colors.blue600,
  error: colors.red600,
})
